import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePlaylistStore } from '@/store/playlist/store';
import { DarkMembersLessonPage } from '@/components/playlist/preview/DarkMembersLessonPage';

export default function DarkMembersLesson() {
  useLanguage();
  const { hash, lessonId } = useParams<{ hash: string; lessonId: string }>();
  const navigate = useNavigate();
  const { getPlaylistByHash } = usePlaylistStore();

  const playlist = hash ? getPlaylistByHash(hash) : null;
  
  // Encontrar a aula e o módulo
  let lesson = null;
  let module = null;
  
  if (playlist?.darkMembersSettings?.modules) {
    for (const mod of playlist.darkMembersSettings.modules) {
      const foundLesson = mod.lessons.find(l => l.id === lessonId);
      if (foundLesson) {
        lesson = foundLesson;
        module = mod;
        break;
      }
    }
  }

  if (!playlist || !lesson || !module || playlist.template !== 'dark-members') {
    return (
      <div className="min-h-screen bg-[#0E0E0E] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-white text-2xl font-bold mb-2">
            {translateInterfaceText("Aula não encontrada")}</h1>
          <p className="text-gray-400">
            {translateInterfaceText("Verifique se o link está correto.")}</p>
        </div>
      </div>
    );
  }

  const handleBack = () => {
    navigate(`/members/${hash}/module/${module.id}`);
  };

  return (
    <DarkMembersLessonPage 
      lesson={lesson}
      module={module}
      onBack={handleBack}
    />
  );
}
